import React from 'react';
import P, { InferProps } from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import User from './user';

function UserRoute({ match }: InferProps<typeof UserRoute.propTypes>) {
  return (
    <Switch>
      <Route exact path={match.url} render={() => <User />} />
    </Switch>
  );
}

UserRoute.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default UserRoute;
